module.exports = __webpack_public_path__ + "img/icon-lamp.7cf93f7e.png";